const DataSkills = {
    languages: "PHP, JavaScript, Python",
    framework: "Laravel, React, Node.js, Express.js",
    db: "MySQL, MongoDB",
    web: "HTML, CSS, Bootstrap, Tailwind CSS",
    tools: "Git, GitHub, Insomnia",
    others: "APIs REST, integración frontend-backend, JWT",
}

export default DataSkills;